import { Box, Flex } from "@chakra-ui/react";
import { APP_PLATFORM } from "../../config";
import { Platform } from "../../models";
import { Content } from "../Content";
import { Header } from "../Header";
import { Sidebar } from "../Sidebar";
import IFrameComponent from "./IFrameComponent";
import { AlertDialogModal, Typography } from "@reconvert/react-ui-component";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useCallback, useRef, useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { selectUnsavedState, setShowUnSaveModelInfo } from "../../app/slice/unsavedSlice";
import useUnsavedBar from "../../hooks/useUnsavedBar";
import { useDirection } from "../../hooks/useDirection";
import ReviewStickyWidgetV2 from "../ReviewCollector/ReviewStickyWidgetV2";
import WelcomePage from "../WelcomePage";
import { useLocation } from "react-router-dom";
import HelpModal from "../HelpModal/HelpModal";

const PageLayout = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const showWelcomePage = queryParams.get("showWelcomePage") || "";
  const cancelRef = useRef<HTMLButtonElement>(null);
  const { t } = useTranslation();
  const { showUnSaveModelInfo } = useAppSelector(selectUnsavedState);
  const { handleDiscard, handleSave } = useUnsavedBar();
  const { direction } = useDirection();
  const closeUnSavedModal = useCallback(() => {
    dispatch(setShowUnSaveModelInfo({ callback: () => {} }));
  }, [dispatch]);

  const [showFlowBuilder, setShowFlowBuilder] = useState(true);

  useEffect(() => {
    if (showWelcomePage === "true") {
      setShowFlowBuilder(false);
    }
  }, [showWelcomePage]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        height: "100vh",
      }}
    >
      {APP_PLATFORM === Platform.Wix && <Header />}
      <Flex flex={1} minHeight={0}>
        <Sidebar showFlowBuilder={showFlowBuilder} setShowFlowBuilder={setShowFlowBuilder} />
        {APP_PLATFORM === Platform.Shopify && <ReviewStickyWidgetV2 />}
        {!showFlowBuilder && APP_PLATFORM === Platform.Shopify ?  <WelcomePage /> : <Content />}
      </Flex>
      <IFrameComponent />
      <AlertDialogModal
        title={t('Would you like to save your changes?')}
        okButtonText={t("Save")}
        cancelButtonText={t('Discard')}
        size={"2xl"}
        isOpen={showUnSaveModelInfo.open}
        leastDestructiveRef={cancelRef}
        onClose={closeUnSavedModal}
        okButtonOnClick={async () => {
          const response = await handleSave();

          response && showUnSaveModelInfo?.callback();
          closeUnSavedModal();
        }}
        cancelButtonOnClick={()=>{
          handleDiscard();
          showUnSaveModelInfo.callback();
          closeUnSavedModal();
        }}
        showCloseButton={true}
        isOkButtonPrimary={true}
        cancelButtonVariant="secondary"
        direction={direction}
      >
        <Typography variant="subheading2">
          {t('Warning: Clicking discard at this stage will delete any unsaved changes')}
        </Typography>
      </AlertDialogModal>
      <HelpModal />
    </Box>
  );
};

export default PageLayout;
